import React from 'react';

const DashboardModalContext = React.createContext({
  onModalHide: () => {},
});

export default DashboardModalContext;
